import { useState, useEffect, useCallback } from 'react';

import axios, { AxiosError, AxiosRequestConfig } from 'axios';

type FetchProps<T> = {
	isLoading: boolean;
	response: T | null;
	error: (AxiosError & { data?: { code: string; message: string } }) | null;
	status: number | null;
};
type DoFetchType<P> = [FetchProps<P>, (params: AxiosRequestConfig) => void];

export const useFetch = <T>(): DoFetchType<T> => {
	const [isLoading, setIsLoading] = useState(false);
	const [response, setResponse] = useState<T | null>(null);
	const [status, setStatus] = useState<number | null>(null);
	const [error, setError] = useState<AxiosError | null>(null);
	const [options, setOptions] = useState<AxiosRequestConfig>({});
	const doFetch = useCallback(async (option = {}) => {
		setOptions(option);
		setIsLoading(true);
		setError(null);
		setResponse(null);
		setStatus(null);
	}, []);

	useEffect(() => {
		if (isLoading) {
			axios(options)
				.then(res => {
					setResponse(res.data);
					setStatus(res.status);
					setIsLoading(false);
				})
				.catch(err => {
					setError(err.response);
					setIsLoading(false);
				});
		}
	}, [isLoading, options]);

	return [{ isLoading, response, error, status }, doFetch];
};
